import { createElementBlock as e, openBlock as o, renderSlot as c } from "vue";
import n from "./index231.js";
const r = {}, s = {
  class: "italic",
  "data-component": "MsItalic"
};
function a(t, l) {
  return o(), e("span", s, [
    c(t.$slots, "default")
  ]);
}
const f = /* @__PURE__ */ n(r, [["render", a]]);
export {
  f as default
};
